import { Card } from "components/shared/DragAndDrop/Card";
import { useEffect } from "react";
import { useCallback, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { deleteSection } from "store/actions";
import Swal from "sweetalert2";

export const Table = ({ data }) => {
  const { locale, formatMessage } = useIntl();
  // eslint-disable-next-line no-lone-blocks
  const [cards, setCards] = useState([]);
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  console.log("data", data);
  console.log("cards", cards);
  useEffect(() => {
    setCards(data);
  }, [data]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleEditProject = (slug) => {
    navigate(`/services/${slug}`);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleDeleteProject = (slug) => {
    Swal.fire({
      title: "هل تريد حذف القسم",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#2a89f3",
      cancelButtonColor: "#d33",
      confirmButtonText: "نعم",
      cancelButtonText: "لا",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteSection({ slug: slug, page: "services" }));
      }
    });
  };

  const renderCard = useCallback(
    (card, index) => (
      <Card
        index={index}
        handleEdit={handleEditProject}
        handleDelete={handleDeleteProject}
        id={card.slug}
        text={card.heading}
        card={card}
      />
    ),

    [handleDeleteProject, handleEditProject]
  );
  return (
    <>
      <div className="dragable_table_body__ ">
        <div className="dragable_table_title__">
          <FormattedMessage id={"title"} />
        </div>
        <div className="dragable_table__">
          {cards?.map((card, i) => (
            <Card
              index={i}
              handleEdit={handleEditProject}
              handleDelete={handleDeleteProject}
              id={card.slug}
              text={card.heading}
              card={card}
            />
          ))}
        </div>
      </div>
      {isLoading ? <div className="lds-dual-ring"></div> : ""}
    </>
  );
};

export default Table;
